import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextInput,
  TextField,
  SelectInput,
  ReferenceArrayInput,
  translate as t,
  UPDATE,
} from 'admin-on-rest';
import {
  Dialog,
  FlatButton,
  RaisedButton,
  TextField as MdTextField,
} from 'material-ui';

import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import { kunal } from '../client';
import kunalClient from '../client/kunalClient';

import { callApi } from '../client/apiToolbox';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import RichTextInput from '../components/inputs/RichTextInput';
import { getTranslationByLocale } from '../utils/TranslationUtils';
import RichTextField from '../components/fields/RichTextField';
import SelectArrayInput from '../components/inputs/SelectArrayInput';
import TagsInput from '../components/inputs/TagsInput';
import ImageInput from '../components/inputs/ImageInput';
import ThumbnailImageField from '../components/fields/ThumbnailImageField';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);

const styles = {
  dialog: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  success: {
    color: 'green',
    textAlign: 'center',
  },
  apiError: {
    color: 'red',
    textAlign: 'center',
  },
};

export const NewsList = t((props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="language" label={props.translate('language')} />
      <TextField source="title" label={props.translate('title')} />
      <EditButton {...props} basePath="/news" />
      <DeleteButton {...props} basePath="/news" />
    </Datagrid>
  </List>
));

// eslint-disable-next-line no-shadow
const NewsTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.title }) : ''}</span>
));

export const NewsEdit = t((props) => (
  <Edit title={<NewsTitle />} {...props}>
    <SimpleForm>
      <SelectInput
        source="language"
        choices={[
          { id: 'en', name: 'English' },
          { id: 'sv', name: 'Svenska' },
        ]}
        label={props.translate('language')}
      />
      <TextInput source="title" label={props.translate('title')} />
      <ReferenceArrayInput source="positions" reference="positions" allowEmpty>
        <SelectArrayInput
          source="positions"
          optionText={(choice) =>
            getTranslationByLocale(choice.name, props.locale)
          }
        />
      </ReferenceArrayInput>

      <ReferenceArrayInput source="markets" reference="markets" allowEmpty>
        <SelectArrayInput
          source="countryCode"
          optionText={(choice) =>
            getTranslationByLocale(choice.title, props.locale)
          }
        />
      </ReferenceArrayInput>

      <SelectArrayInput
        source="areas"
        allowEmpty
        choices={[
          { id: 'north', name: props.translate('news.north') },
          { id: 'central', name: props.translate('news.central') },
          { id: 'south', name: props.translate('news.south') },
        ]}
      />

      <ReferenceArrayInput
        source="tags"
        reference="news"
        allowEmpty
        label={props.translate('tag')}
      >
        <TagsInput />
      </ReferenceArrayInput>
      <ImageInput source="thumbnail" accept="image/*">
        <ThumbnailImageField source="src" />
      </ImageInput>
      <RichTextInput
        source="body"
        label={props.translate('news.news')}
        options={{
          config: {
            toolbar:
              'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | numlist bullist checklist | outdent indent | link image | code',
          },
        }}
      />
      <RichTextField source="body" label={props.translate('news.news')} />
      <ConnectedSMSWarning />
    </SimpleForm>
  </Edit>
));

export const NewsCreate = t((props) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <SelectInput
        source="language"
        defaultValue="en"
        choices={[
          { id: 'en', name: 'English' },
          { id: 'sv', name: 'Svenska' },
        ]}
        label={props.translate('language')}
      />
      <TextInput source="title" label={props.translate('title')} />
      <ReferenceArrayInput source="positions" reference="positions" allowEmpty>
        <SelectArrayInput
          source="positions"
          optionText={(choice) =>
            getTranslationByLocale(choice.name, props.locale)
          }
        />
      </ReferenceArrayInput>

      <SelectArrayInput
        source="areas"
        allowEmpty
        choices={[
          { id: 'north', name: props.translate('news.north') },
          { id: 'central', name: props.translate('news.central') },
          { id: 'south', name: props.translate('news.south') },
        ]}
      />

      <ReferenceArrayInput source="tags" reference="news" allowEmpty>
        <TagsInput />
      </ReferenceArrayInput>
      <ImageInput source="thumbnail" accept="image/*">
        <ThumbnailImageField source="src" />
      </ImageInput>
      <RichTextInput
        options={{
          config: {
            toolbar:
              'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | numlist bullist checklist | outdent indent | link image | code',
          },
        }}
        source="body"
        label={props.translate('news.news')}
      />
      <RichTextField source="body" label={props.translate('news.news')} />
    </SimpleForm>
  </Create>
));

class SMSWarning extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      isOpen: false,
      sms: '',
      inputError: '',
      apiError: '',
      success: '',
      alreadyNotified: '',
    };
  }
  componentDidMount = async () => {
    const users = await callApi(
      `${API_BASE_URL}/utils/getActiveUsers?filter={}`,
      'GET',
      { 'Content-Type': 'application/json' }
    );
    this.setState({ users: users.json });
  };

  setSendNotification = async () => {
    const { record, translate } = this.props;
    const { sms } = this.state;
    if (!sms) {
      this.setState({ inputError: translate('resources.news.noEmptyBody') });
      return;
    }

    restClient(UPDATE, 'news', {
      id: record.id,
      data: {
        ...record,
        sendNotification: true,
        deliveredNotification: false,
        notificationMessage: sms,
      },
    })
      .then(() =>
        this.setState({
          success: translate('resources.news.smsSuccess'),
          inputError: '',
          apiError: '',
        })
      )
      .catch(() =>
        this.setState({
          apiError: translate('resources.news.smsError'),
          success: '',
        })
      );
  };

  getUsersPerPosition = (users, record) =>
    users.filter((user) => {
      const venues =
        user && user.permissions ? Object.keys(user.permissions) : [];
      const userPositions = venues
        .map(
          (venue) =>
            user && user.permissions && user.permissions[venue].position
        )
        .reduce((acc, next) => [...acc, ...next], []);
      if (
        record.positions &&
        record.positions.some((p) => userPositions.includes(p))
      ) {
        return true;
      }
      return false;
    });

  handleTextChange = (e, sms) => this.setState({ sms });

  openDialog = () => this.setState({ isOpen: true });
  closeDialog = () =>
    this.setState({
      isOpen: false,
      sms: '',
      success: '',
      inputError: '',
      apiError: '',
    });

  render() {
    const { users } = this.state;
    const { record, translate } = this.props;
    if (users.length <= 0 || !record) {
      return null;
    }
    const usersPerPosition = this.getUsersPerPosition(users, record);

    return (
      <div>
        <RaisedButton
          label={translate('resources.news.openSMSDialog')}
          onClick={this.openDialog}
        />
        <p>
          {record.sendNotification &&
            translate('resources.news.alreadyNotified')}
        </p>
        <SMSDialog
          setSendNotification={this.setSendNotification}
          closeDialog={this.closeDialog}
          usersPerPosition={usersPerPosition}
          handleTextChange={this.handleTextChange}
          {...this.state}
          {...this.props}
        />
      </div>
    );
  }
}

const SMSDialog = ({
  users,
  closeDialog,
  record,
  translate,
  isOpen,
  setSendNotification,
  usersPerPosition,
  handleTextChange,
  sms,
  inputError,
  success,
  apiError,
}) => (
  <Dialog
    open={isOpen}
    onRequestClose={closeDialog}
    actions={[
      <FlatButton onClick={closeDialog} label={translate('close')} />,
      <RaisedButton
        primary
        onClick={setSendNotification}
        label={translate('resources.news.sendSMS')}
      />,
    ]}
  >
    <div style={styles.dialog}>
      {/* <p>{translate('resources.news.sendNotification')}</p> */}

      <MdTextField
        onChange={handleTextChange}
        value={sms}
        fullWidth
        options={{ maxLength: 80, fullWidth: true }}
        label={translate('resources.news.notificationMessage')}
        floatingLabelText={translate('resources.news.notificationMessage')}
        errorText={inputError && inputError}
      />

      {!record.positions || record.positions.length <= 0 ? (
        <div>
          <p>
            {translate('resources.news.amountOfUsersNotification')}{' '}
            {users.length} {translate('resources.news.users')}.
          </p>
          <p>
            {translate('resources.news.smsCost')}{' '}
            {(users.length * 0.55).toFixed()} SEK.
          </p>
          <p>{translate('resources.news.selectPositionNotification')}</p>
          <p>{translate('resources.news.smsDelay')}</p>
        </div>
      ) : (
        <div>
          <p>
            {translate('resources.news.amountOfUsersNotification')}{' '}
            {usersPerPosition.length} {translate('resources.news.users')}.
          </p>
          <p>
            {translate('resources.news.smsCost')}{' '}
            {(usersPerPosition.length * 0.55).toFixed()} SEK.
          </p>
          <p>{translate('resources.news.smsDelay')}</p>
        </div>
      )}

      {success && <div style={styles.success}>{success}</div>}
      {apiError && <div style={styles.apiError}>{apiError}</div>}
    </div>
  </Dialog>
);
const selector = getFormValues('record-form');

const ConnectedSMSWarning = connect((state) => ({ record: selector(state) }))(
  t(SMSWarning)
);
